if (!customElements.get('sb-home-shop')) {
  customElements.define('sb-home-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.cards.forEach((card) => {
        const form = card.querySelector('.sb-home-shop__form');
        const variant = card.querySelector('[data-variant]');
        const quantity = card.querySelector('[data-quantity]');
        variant.addEventListener('change', () => { card.querySelector('[data-feedback]').textContent = ''; this.update(card); });
        quantity.addEventListener('change', () => { card.querySelector('[data-feedback]').textContent = ''; this.update(card); });
        form.addEventListener('submit', (event) => this.add(event, card));
        this.update(card);
      });
    }

    validQuantity(option, quantity) {
      const minimum = Number(option.dataset.min) || 1;
      const increment = Number(option.dataset.increment) || 1;
      const maximum = Number(option.dataset.max) || Infinity;
      const stock = Number(option.dataset.stock);
      return quantity >= minimum && quantity <= maximum && (quantity - minimum) % increment === 0 && (stock < 0 || quantity <= stock);
    }

    money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency || 'USD'
      }).format(cents / 100);
    }

    update(card) {
      const variant = card.querySelector('[data-variant]');
      const quantity = card.querySelector('[data-quantity]');
      const selected = variant.selectedOptions[0];
      const single = quantity.querySelector('[value="1"]');
      const pack = quantity.querySelector('[value="10"]');
      single.disabled = !selected || selected.disabled || !this.validQuantity(selected, 1);
      pack.disabled = !selected || selected.disabled || !this.validQuantity(selected, 10);
      if (quantity.selectedOptions[0]?.disabled) {
        quantity.value = single.disabled && !pack.disabled ? '10' : '1';
      }
      const allowed = selected && !selected.disabled && !quantity.selectedOptions[0]?.disabled;
      const price = Number(selected?.dataset.price) || 0;
      card.querySelector('[data-unit-price]').textContent = this.money(price);
      card.querySelector('[data-total-price]').textContent = this.money(price * Number(quantity.value));
      card.querySelector('[data-submit]').disabled = !allowed || card.dataset.pending === 'true';
      const image = card.querySelector('img.sb-home-shop__image');
      if (image && selected?.dataset.image && image.src !== selected.dataset.image) {
        image.src = selected.dataset.image;
        image.removeAttribute('srcset');
        image.alt = selected.dataset.imageAlt || '';
      }
      if (!allowed) card.querySelector('[data-feedback]').textContent = this.dataset.pickColor;
    }

    async add(event, card) {
      if (!window.fetch) return;
      event.preventDefault();
      if (card.dataset.pending === 'true') return;
      const selected = card.querySelector('[data-variant]').selectedOptions[0];
      const quantity = Number(card.querySelector('[data-quantity]').value);
      if (!selected || selected.disabled || !this.validQuantity(selected, quantity)) return;
      const button = card.querySelector('[data-submit]');
      const feedback = card.querySelector('[data-feedback]');
      card.dataset.pending = 'true';
      button.disabled = true;
      card.querySelector('[data-variant]').disabled = true;
      card.querySelector('[data-quantity]').disabled = true;
      button.textContent = this.dataset.adding;
      feedback.textContent = '';
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: Number(selected.value), quantity })
        });
        if (!response.ok) throw new Error((await response.json().catch(() => ({}))).description || this.dataset.addError);
        feedback.textContent = this.dataset.added;
        card.querySelector('[data-cart-link]').hidden = false;
        try {
          if (typeof window.monster_refresh === 'function') {
            Promise.resolve(window.monster_refresh()).catch((error) => console.warn('[home-shop] Cart refresh failed', error));
          }
        } catch (error) {
          console.warn('[home-shop] Cart refresh failed', error);
        }
      } catch (error) {
        feedback.textContent = error.message || this.dataset.addError;
      } finally {
        card.dataset.pending = 'false';
        card.querySelector('[data-variant]').disabled = false;
        card.querySelector('[data-quantity]').disabled = false;
        button.textContent = button.dataset.addLabel;
        this.update(card);
      }
    }
  });
}
